export default "__VITE_ASSET__46bW2m0B__"